import React from "react";

const T12 = ({
  color = "red",
  height = 80,
  width = 80,
  isCompleted,
  filling,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 101 326"
      fill="none"
    >
      <path
        d="M69.6661 207.962C50.4661 191.862 17.2661 196.462 6.26609 232.262C5.06609 216.262 3.46609 194.162 4.26609 176.362C5.56609 148.662 9.06609 135.962 18.0661 91.462C24.0661 60.462 11.3661 32.962 6.86609 18.762C2.36609 4.56201 10.5661 0.0620122 15.2661 2.66201C19.9661 5.26201 51.7661 29.762 65.3661 72.562C77.6661 111.362 81.9661 171.962 86.9661 231.462C82.7661 222.162 77.1661 214.262 69.6661 207.962Z"
        fill={`${
          filling?.fullTooth || filling?.crownFilling
            ? color
            : "url(#paint0_linear_1055_775)"
        }`}
      />
      <path
        d="M4.76609 238.062C5.16609 236.062 5.76609 234.162 6.26609 232.262C17.2661 196.462 50.4661 191.762 69.6661 207.962C77.1661 214.262 82.7661 222.162 86.9661 231.462C94.0661 247.162 97.2661 266.962 99.2661 290.262C102.466 327.462 84.4661 324.862 71.3661 324.262C64.2661 323.862 39.7661 322.362 22.9661 314.362C6.26608 306.362 -4.33391 279.062 4.76609 238.062Z"
        fill={`${
          filling?.fullTooth || filling?.rootFilling
            ? color
            : "url(#paint1_linear_1055_775)"
        }`}
      />
      <path
        d="M4.26609 176.362L3.26718 176.315L3.2671 176.317L4.26609 176.362ZM18.0661 91.462L19.0463 91.6602L19.0479 91.652L18.0661 91.462ZM65.3661 72.562L66.3193 72.2598L66.3191 72.2592L65.3661 72.562ZM86.9661 231.462L86.0547 231.874L86.0549 231.874L86.9661 231.462ZM4.76609 238.062L5.74233 238.279C5.74385 238.272 5.74529 238.265 5.74667 238.258L4.76609 238.062ZM99.2661 290.262L98.2697 290.348L98.2698 290.348L99.2661 290.262ZM71.3661 324.262L71.3098 325.26L71.3203 325.261L71.3661 324.262ZM22.9661 314.362L22.5341 315.264L22.5361 315.265L22.9661 314.362ZM69.6661 207.962L70.3086 207.196C60.458 198.936 47.0105 195.98 34.6045 199.691C22.1689 203.412 10.8952 213.792 5.31019 231.968L6.26609 232.262L7.22198 232.556C12.637 214.932 23.4633 205.112 35.1777 201.608C46.9216 198.094 59.6742 200.888 69.0235 208.728L69.6661 207.962ZM6.26609 232.262L7.26329 232.187C6.06235 216.175 4.46825 194.136 5.26508 176.407L4.26609 176.362L3.2671 176.317C2.46392 194.188 4.06982 216.349 5.26889 232.337L6.26609 232.262ZM4.26609 176.362L5.26499 176.409C6.56045 148.806 10.0378 136.202 19.0462 91.6602L18.0661 91.462L17.0859 91.2638C8.09439 135.722 4.57173 148.518 3.26719 176.315L4.26609 176.362ZM18.0661 91.462L19.0479 91.652C25.1095 60.3336 12.2716 32.5091 7.81936 18.4599L6.86609 18.762L5.91281 19.0641C10.4606 33.415 23.0227 60.5904 17.0843 91.272L18.0661 91.462ZM6.86609 18.762L7.81936 18.4599C5.62187 11.5256 6.61438 7.24883 8.39474 5.03947C10.1739 2.83162 12.8696 2.47912 14.782 3.53705L15.2661 2.66201L15.7501 1.78698C12.9626 0.244905 9.2083 0.842403 6.83744 3.78455C4.46779 6.72519 3.6103 11.7984 5.91281 19.0641L6.86609 18.762ZM15.2661 2.66201L14.782 3.53705C16.995 4.76123 26.0317 11.4453 36.2232 23.1923C46.3954 34.917 57.664 51.6252 64.413 72.8648L65.3661 72.562L66.3191 72.2592C59.4682 50.6988 48.0368 33.757 37.7339 21.8817C27.4505 10.0287 18.2372 3.16279 15.7501 1.78698L15.2661 2.66201ZM65.3661 72.562L64.4128 72.8642C76.6698 111.528 80.964 171.98 85.9696 231.546L86.9661 231.462L87.9626 231.378C82.9681 171.944 78.6624 111.196 66.3193 72.2598L65.3661 72.562ZM86.9661 231.462L87.8775 231.05C83.6263 221.637 77.9422 213.608 70.3093 207.196L69.6661 207.962L69.0229 208.728C76.3899 214.916 81.9059 222.687 86.0547 231.874L86.9661 231.462ZM4.76609 238.062L5.74667 238.258C6.13918 236.296 6.71648 234.48 7.23316 232.516L6.26609 232.262L5.29901 232.008C4.81569 233.844 4.193 235.828 3.78551 237.866L4.76609 238.062ZM6.26609 232.262L7.22198 232.556C12.6372 214.932 23.4641 205.087 35.1786 201.57C46.9217 198.044 59.6726 200.838 69.0212 208.726L69.6661 207.962L70.311 207.198C60.4596 198.886 47.0105 195.93 34.6036 199.654C22.1681 203.387 10.895 213.792 5.31019 231.968L6.26609 232.262ZM86.9661 231.462L86.0549 231.874C93.0805 247.41 96.2712 267.065 98.2697 290.348L99.2661 290.262L100.262 290.176C98.2609 266.859 95.0517 246.915 87.8773 231.05L86.9661 231.462ZM99.2661 290.262L98.2698 290.348C99.8629 308.868 96.1282 317.01 90.864 320.612C88.198 322.435 85.0172 323.19 81.6295 323.436C78.2265 323.684 74.7314 323.415 71.4118 323.263L71.3661 324.262L71.3203 325.261C74.5507 325.409 78.2182 325.69 81.7746 325.431C85.3462 325.171 88.9217 324.364 91.9932 322.262C98.2039 318.014 101.869 308.856 100.262 290.176L99.2661 290.262ZM71.3661 324.262L71.4223 323.264C64.2916 322.862 39.9905 321.361 23.396 313.459L22.9661 314.362L22.5361 315.265C39.5417 323.363 64.2405 324.862 71.3098 325.26L71.3661 324.262ZM22.9661 314.362L23.3981 313.46C15.3831 309.621 8.70257 301.082 5.15455 288.319C1.60864 275.564 1.21862 258.66 5.74233 238.279L4.76609 238.062L3.78984 237.845C-0.786449 258.464 -0.426465 275.71 3.22762 288.855C6.8796 301.992 13.849 311.103 22.5341 315.264L22.9661 314.362Z"
        fill={`${!isCompleted ? "#98814C" : "#FFFFFF"}`}
        strokeWidth="4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1055_775"
          x1="1.4058"
          y1="163.241"
          x2="99.628"
          y2="163.241"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B59B6F" />
          <stop offset="0.1062" stop-color="#C0AA84" />
          <stop offset="0.3663" stop-color="#D8CCB3" />
          <stop offset="0.4964" stop-color="#E1D9C5" />
          <stop offset="0.6627" stop-color="#D0C1A4" />
          <stop offset="0.8839" stop-color="#BDA67E" />
          <stop offset="1" stop-color="#B59B6F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1055_775"
          x1="1.40644"
          y1="261.786"
          x2="99.6741"
          y2="261.786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B59B6F" />
          <stop offset="0.0189621" stop-color="#C2AD89" />
          <stop offset="0.0470928" stop-color="#D3C3A8" />
          <stop offset="0.0790017" stop-color="#E0D6C4" />
          <stop offset="0.115" stop-color="#ECE5DA" />
          <stop offset="0.1571" stop-color="#F4F1EB" />
          <stop offset="0.2091" stop-color="#FBF9F6" />
          <stop offset="0.2821" stop-color="#FEFEFD" />
          <stop offset="0.4847" stop-color="white" />
          <stop offset="0.7001" stop-color="#FEFEFD" />
          <stop offset="0.7777" stop-color="#FBF9F6" />
          <stop offset="0.833" stop-color="#F4F1EB" />
          <stop offset="0.8777" stop-color="#ECE5DA" />
          <stop offset="0.916" stop-color="#E0D6C4" />
          <stop offset="0.9499" stop-color="#D3C3A8" />
          <stop offset="0.9798" stop-color="#C2AD89" />
          <stop offset="1" stop-color="#B59B6F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default T12;
